export const OUTPUT_STATUS = {
  VOIDED: -1,
  COMPLETED_ITEMS: 0,
  FINISHED: 1,
  INCOMPLETE_ITEMS: 2,
  LINKED_ORDER: 3
}